import * as OFMSUI from "react-bootstrap"; import "bootstrap/dist/css/bootstrap.min.css"; import { Formik, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup"; import React, { useEffect, useState } from "react"; import { useHistory } from "react-router-dom"; import { Form, InputGroup, Button, Table } from "react-bootstrap"; import MuiAlert from "@mui/material/Alert"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import Swal from "sweetalert2"; import HousingService from "../../../Services/HousingService"; import axios from "axios";
import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai"; import { cloud_url } from "../../../Services/Configuration"; import Select from "react-select"; import { FaFastBackward } from "react-icons/fa"; import moment from "moment-timezone";
import { AlphaNumericValidation, NumberValidation } from "../../utils/commonFunctions";

const GenerationReceipt = () => {
  const history = useHistory();
  const [chequeddreceiptnoflag, setchequeddreceiptnoflag] = useState(false);
  const [mode, setmode] = useState();
  const [selectedHeadIds, setSelectedHeadIds] = useState([]);
  const [headercount, setHeadercount] = useState(1);
  const [headNamesList, setheadNamesList] = useState([]);
  const [bankNamesList, setbankNamesList] = useState();
  const [transactionId, setTransactionId] = useState();
  const [bankList, setbankList] = useState();
  const [bankblncflag, setBankblncflag] = useState(false);
  const [selectedbnkacc, setselectedbnkacc] = useState();
  const [subheadresdata, setSubheadresdata] = useState();
  const [Modevalidationflag, setModevalidationflag] = useState(false);
  const [formdata, setFormdata] = useState();
  const [number, setnumber] = useState(0);
  const [Headsum, setHeadSum] = useState();
  const [headSelected, setHeadSelected] = useState(false);







  const [postsubmitted, setPostsubmitted] = useState(false);

  React.useEffect(() => {
    let params = {
      save_flag_Payment_Receipts_Journal: "Receipt",
    };
    HousingService.getPaymentReceiptId(params).then((res) => { const id = res.data[0].payment_receipt_id; setTransactionId(id); });
    handleHeadNames();
  }, []);

  const transactionTypeChange = (e, field) => {
    const transactionCheck = e.target.value;
    if (transactionCheck === "Bank") {
      setBankblncflag(true);
      HousingService.fetchBank().then((res) => {
        if (res.data) {
          setbankList(res.data);
          let options = res.data.map((item, i) => { return (<option key={i} value={item.banknameaccountno}> {item.banks} </option>); });
          setbankNamesList(options);
        }
      }).catch(() => setTimeout(() => { }, 1000));
    } else { setBankblncflag(false); }
    field.onChange(e);
  };

  const [displayblncselected, setdisplayblncselected] = useState();
  const displaybalance = (e, field, values, setValues) => {
    field.onChange(e);

    setselectedbnkacc(e.target.value); const selectedvalue = e.target.value;
    bankList.filter((item) => item.banknameaccountno === selectedvalue).map((filteredItem) => { setdisplayblncselected(filteredItem.remaining_balance); return filteredItem.remaining_balance; });
  };
  const handleHeadNames = () => {
    HousingService.fetchHeadNamesDropdowns().then((res) => {
      setSubheadresdata(res.data); if (res.data) {
        let options = res.data.map((item, i) => {
          return (<option key={i} value={item.headid}> {item.heads} </option>);
        });
        setheadNamesList(options);
      }
    });
  };

  const [hdnm, setHdnm] = useState();

  const subhandleHeadNames = (e, field, values, setFieldValue, i) => {
    const { headsname, value } = e.target;
    field.onChange(e);
    const selectedheadname = e.target.value;
    HousingService.fetchSubHeadName(selectedheadname).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (<> <option key={i} value={item.subheadseqid}> {item.subheads} </option> </>);
        });
        setFieldValue(
          `dummy_journal_voucher_heads_Req.${i}.subHeadOptions`,
          options
        );
      }
    });
  };

  const [repeatsubhead, setRepeatsubhead] = useState();
  const subNames = (e, field, values, setValues) => {
    field.onChange(e);
    const subheadvalue = e.target.value;
    setRepeatsubhead(subheadvalue);
  };
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  function addingHeaders(e, values, setValues) {
    const dummy_journal_voucher_heads_Req = [
      ...values.dummy_journal_voucher_heads_Req,
    ];
    const addHeaders = e.target.value || 0;

    for (let i = 1; i <= number; i++) {
      dummy_journal_voucher_heads_Req.push({
        headid: "",
        subheadid: "",
        credit: "",
      });
      setHeadercount(headercount + 1);
      setValues({ ...values, dummy_journal_voucher_heads_Req });
      setHdnm();
    }
  }

  const today = new Date().toISOString().split('T')[0];

  const onChangePaymentMode = (e, field, values, setValues) => {
    setModevalidationflag(true);
    const mode = e.target.value;
    setmode(mode);

    setValues({ ...values, mode });
    field.onChange(e);
    if (mode) {
      setchequeddreceiptnoflag(true);
    } else {
      setchequeddreceiptnoflag(false);
    }
  };
  const changeIconadd = () => {
    alert("sample");
    addingHeaders();
  };

  function addHead(e, values, setValues) {
    const dummy_journal_voucher_heads_Req = [
      ...values.Payment_Receidummy_journal_voucher_heads_Reqpts_Subheads,
    ];
    const addHeaders = e.target.value || 0;
    const lengthsubhead = values.dummy_journal_voucher_heads_Req.length;
    var headsum = 0;
    for (let i = 0; i < lengthsubhead; i++) {
      const subheadval = values.dummy_journal_voucher_heads_Req[i];
      headsum = parseInt(subheadval.credit) + headsum;

    }
    setHeadSum(headsum);


    dummy_journal_voucher_heads_Req.push({
      headid: "",
      subhheadid: "",
      credit: "",
    });
    setValues({ ...values, dummy_journal_voucher_heads_Req });
    setHeadercount(headercount + 1);
  }

  const showNotification = (type, message) => {
    if (type === "success") {
      Swal.fire("Success", message, "success");
    } else if (type === "error") {
      Swal.fire("Error", message, "error");
    } else if (type === "warning") {
      Swal.fire("Warning", message, "warning");
    } else if (type === "info") {
      Swal.fire("info", message, "info");
    }
  };

  const ref = React.createRef();

  const getPdf = (payment_receipt_id) => {
    HousingService.getRecieptPdf(payment_receipt_id).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      let tab = window.open();
      tab.location.href = url;
      setTimeout(() => {
        resetForm();
        window.location.reload();
      }, 2000);
    });
  };



  return (
    <>
      {" "}
      <NavigationServicesHeader />
      <Formik
        initialValues={{
          payment_receipt_id: transactionId,
          noofsubheads: number,
          receiptno: "",
          date: today,
          banknameaccountno: "",
          remaining_balance: displayblncselected,
          receiptamount: "",
          name: "",
          mode: "",
          receipt_description: "",
          cheque_dd_receipt_no: "",
          cash_bank: "",
          file: "",
          dummy_journal_voucher_heads_Req: [
            {
              headid: "",
              subheadid: "",
              credit: "",
            },
          ],
        }}
        onSubmit={async (values, { resetForm }) => {
          values.payment_receipt_id = transactionId;
          (values.remaining_balance = displayblncselected);
          setFormdata(values);

          setFormdata(values);
          let params = {
            receiptno: values.receiptno?.trim(),
            fromDate: moment(values.date).format("DD-MM-YYYY"), transaction_type: "R"
          };

          try {
            const res = await HousingService.CheckReceipNo(params);

            if (res.data[0].receipt_exists === true) {
              showNotification(
                "warning",
                "Receipt No. already exists for the selected Received Date."
              );
              return;
            }
          } catch (err) {
            console.error("Receipt check failed", err);
            return;
          }

          const lengthsubhead = values.dummy_journal_voucher_heads_Req.length;
          var headsum = 0;
          const idSet = new Set();
          for (let i = 0; i < lengthsubhead; i++) {
            const subheadval = values.dummy_journal_voucher_heads_Req[i];
            headsum = parseInt(subheadval.credit) + headsum;
            const idPair = subheadval.headid + subheadval.subheadid;

            if (idSet.has(idPair)) {
              showNotification(
                "error",
                "Duplicate headid and subheadid found!"
              );
              return;
            } else {
              // Add the unique pair to the Set
              idSet.add(idPair);
            }
          }
          setHeadSum(headsum);
          if (parseInt(values.receiptamount) == headsum) {
            try {
              Swal.fire({
                text: "Do you want Submit?",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
              }).then((result) => {
                if (result.isConfirmed) {
                  let file = document.getElementById("file").files[0];
                  let formData = new FormData();
                  formData.append("file", file);
                  HousingService.fileUploadUrl(formData).then((res) => {
                    if (res.data !== null && res.data !== undefined) {
                      let date = moment(values.date).format("YYYY-MM-DD")
                      values.date = date
                      values.upload_copy = res.data
                      HousingService.Generation_Receipt_Insertion(values).then(
                        async (response) => {
                          if (response?.data?.SCODE === "01") {
                            showNotification("success", "Submitted successfully");
                            await getPdf(values?.payment_receipt_id);
                            setTimeout(() => {
                              resetForm();
                              window.location.reload();
                            }, 1000);
                          }
                          else{
                            showNotification("error", "File name should not contain symbols or special characters.");
                          }
                        }
                      );
                    }
                  })

                }
              });
            } catch (error) {
              console.error("Error uploading file:", error);
              // Handle error cases
            }
          } else {
            showNotification(
              "error",
              "Total Subhead Amount Should be Equal to Amount Received"
            );
          }
        }}
        validationSchema={Yup.object({
          receiptno: Yup.string().required("receiptno is required"),
          date: Yup.date().max(new Date()).required("date is required"),
          // .max(maxiDate, "Should Select Today Date")
          // .min(miniDate, "Should Select Today Date"),
          file: Yup.string().required("file is required"),
          cash_bank: Yup.string().required("transaction Type is required"),
          banknameaccountno: bankblncflag ? Yup.string().required() : Yup.string(),
          receiptamount: Yup.number().required("amount received is required") .typeError("amount received should be number"),
          name: Yup.string().required("amount received from is required"),
          mode: Yup.string().required("mode is required"),
          receipt_description: Yup.string().required("receipt description is required"),
          cheque_dd_receipt_no: Modevalidationflag
            ? Yup.string().required("required")
            : Yup.string(),
          dummy_journal_voucher_heads_Req: Yup.array().of(
            Yup.object().shape({
              headid: Yup.string().required(),
              credit: Yup.number()
                .required("Credit amount is required")
                .typeError("Credit amount should be a number"),
            })
          ),
        })}
      >
        {({ formik, errors, values, touched, setFieldValue, setValues, handleSubmit, resetForm, handleChange }) => !postsubmitted ? (
          <Form onSubmit={handleSubmit}>
            <OFMSUI.Container fluid style={{ width: "90%" }}>
              <OFMSUI.Row>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                  <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: "-15px" }}> Generation of Receipt Voucher </h1> </div>
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                  <button className="btn btn-primary btn-sm" style={{ textAlign: "right", float: "right", marginTop: "30px", backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type="reset" onClick={() => history.goBack()} > <FaFastBackward /> &nbsp;Back </button>
                  <div className="d-grid  "></div>
                </OFMSUI.Col>
              </OFMSUI.Row>
            </OFMSUI.Container>
            <OFMSUI.Container className="outer-page-content-container " height="100vh" fluid style={{ width: "90%" }}>
              <OFMSUI.Row className="p-4">
                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                  <label>
                    <b>Transaction ID No</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    value={transactionId}
                    name="payment_receipt_id"
                    className={
                      touched.payment_receipt_id && errors.payment_receipt_id
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                    // maxLength={10}
                    disabled={true}
                  />
                  {touched.payment_receipt_id && errors.payment_receipt_id ? (
                    <div className="invalid-feedback">
                      {errors.payment_receipt_id}
                    </div>
                  ) : null}
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                  <label>
                    <b>Receipt No</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="receiptno"
                    className={
                      touched.receiptno && errors.receiptno
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                    maxLength={10}
                    onKeyPress={(e) => AlphaNumericValidation(e)}
                  />
                  {touched.receiptno && errors.receiptno ? (
                    <div className="invalid-feedback">{errors.receiptno}</div>
                  ) : null}
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                  <label>
                    <b>Received Date</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="date"
                    className={
                      touched.date && errors.date
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="date"
                    max={today}
                    min="2024-01-01"
                  // disabled={true}
                  />
                  {touched.date && errors.date ? (
                    <div className="invalid-feedback">{errors.date}</div>
                  ) : null}
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                  <label>
                    <b>Type of Transaction</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field name="cash_bank">
                    {({ field }) => (
                      <select
                        {...field}
                        className={
                          "form-control" +
                          (errors.cash_bank && touched.cash_bank
                            ? " is-invalid"
                            : "")
                        }
                        value={values?.cash_bank || ""}
                        onChange={(e) => transactionTypeChange(e, field)}
                      >
                        <option value="">--Select--</option>
                        <option value="Bank">Bank</option>
                        {/* <option value="Cash">Cash</option> */}

                      </select>
                    )}
                  </Field>
                  {touched.cash_bank && errors.cash_bank ? (<div className="invalid-feedback">{errors.cash_bank}</div>) : null}
                </OFMSUI.Col>

                {bankblncflag && (
                  <>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className="mb-3"
                    >
                      <label>
                        <b>Bank Name/Account No</b>
                      </label>
                      <span className="mandatory" style={{ color: "red" }}>
                        {" "}
                        *{" "}
                      </span>
                      <Field name="banknameaccountno">
                        {({ field }) => (
                          <select
                            {...field}
                            onChange={(e) =>
                              displaybalance(e, field, values, setValues)
                            }
                            className={
                              "form-control" +
                              (errors.banks && touched.banks
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option value="">--Select--</option>
                            {bankNamesList}
                          </select>
                        )}
                      </Field>
                    </OFMSUI.Col>
                  </>
                )}

                {bankblncflag && (
                  <>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className="mb-3"
                    >
                      <label>
                        <b>Bank Balance</b>
                      </label>
                      <span className="mandatory" style={{ color: "red" }}>
                        {" "}
                        *{" "}
                      </span>
                      <Field
                        name="balance_in_account"
                        value={displayblncselected}
                        maxLength={15}
                        disabled={true}
                        className={
                          touched.balance_in_account &&
                            errors.balance_in_account
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                    </OFMSUI.Col>
                  </>
                )}
                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                  <label>
                    <b>Amount Received </b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="receiptamount"
                    className={
                      touched.receiptamount && errors.receiptamount
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                    maxLength={15}
                    onKeyPress={(e) => NumberValidation(e)}
                  />
                  {touched.receiptamount && errors.receiptamount ? (
                    <div className="invalid-feedback">{errors.receiptamount}</div>
                  ) : null}
                </OFMSUI.Col>

                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                  <label>
                    <b>Amount Received From</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    name="name"
                    className={
                      touched.name && errors.name
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    type="text"
                  // maxLength={30}
                  // onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                  />
                                  {touched.name && errors.name ? (
                    <div className="invalid-feedback">{errors.name}</div>
                  ) : null}
                </OFMSUI.Col>


                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                  <label>
                    <b>Description of Receipt</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field
                    style={{ height: "38px" }}
                    name="receipt_description"
                    as="textarea"
                    // onKeyPress={(e) => allowAlphabetAndSpacesOnly(e)}
                    className={
                      touched.receipt_description &&
                        errors.receipt_description
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                  />
                  {touched.receipt_description &&
                    errors.receipt_description ? (
                    <div className="invalid-feedback">
                      {errors.receipt_description}
                    </div>
                  ) : null}
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                  <label>
                    <b>Received Mode</b>
                  </label>
                  <span className="mandatory" style={{ color: "red" }}>
                    {" "}
                    *{" "}
                  </span>
                  <Field name="mode">
                    {({ field }) => (
                      <select
                        {...field}
                        className={
                          "form-control" +
                          (errors.mode && touched.mode ? " is-invalid" : "")
                        }
                        onChange={(e) =>
                          onChangePaymentMode(e, field, values, setValues)
                        }
                      >
                        <option value="">--Select--</option>
                        <option value="Cheque">Cheque/DD/ReceiptNo</option>
                        <option value="DD">DD</option>
                        <option value="Online"> Online </option>
                      </select>
                    )}
                  </Field>
                  {touched.mode && errors.mode ? (
                    <div className="invalid-feedback">{errors.mode}</div>
                  ) : null}
                </OFMSUI.Col>
                {chequeddreceiptnoflag && (
                  <>
                    <OFMSUI.Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={3}
                      xl={3}
                      xxl={3}
                      className="mb-3"
                    >
                      <label>
                        <b>{mode} </b>
                      </label>
                      <span className="mandatory" style={{ color: "red" }}>
                        {" "}
                        *{" "}
                      </span>
                      <Field
                        name="cheque_dd_receipt_no"
                        type="text"
                        // onKeyPress={(e) => NumberValidation(e)}
                        placeholder={mode}
                        className={
                          touched.cheque_dd_receipt_no &&
                            errors.cheque_dd_receipt_no
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                      />
                      {touched.cheque_dd_receipt_no &&
                        errors.cheque_dd_receipt_no ? (
                        <div className="invalid-feedback">
                          {errors.cheque_dd_receipt_no}
                        </div>
                      ) : null}
                    </OFMSUI.Col>
                  </>
                )}
              </OFMSUI.Row>

              <OFMSUI.Row className="px-4 m-0">
                <FieldArray name="dummy_journal_voucher_heads_Req">
                  {({ form, push, remove }) => (
                    <Table striped bordered hover>
                      <thead className="fw-bold">
                        <tr className="table_countshead">
                          <td style={{ width: "1%" }}>S.No</td>
                          <td style={{ width: "50%" }}>Heads Name</td>
                          <td>SubHeads Name</td>
                          <td style={{ width: "20%" }}>Amount</td>
                          <td>Add Row</td>
                        </tr>
                      </thead>
                      <tbody>
                        {values.dummy_journal_voucher_heads_Req.map(
                          (HeadersList, i) => {
                            const headId =
                              values.dummy_journal_voucher_heads_Req[i]
                                .headid;
                            const isHeadIdSelected =
                              selectedHeadIds.includes(headId);
                            const dummy_journal_voucher_heads_ReqErrors =
                              (errors.dummy_journal_voucher_heads_Req
                                ?.length &&
                                errors.dummy_journal_voucher_heads_Req[i]) ||
                              {};
                            const dummy_journal_voucher_heads_ReqTouched =
                              (touched.dummy_journal_voucher_heads_Req
                                ?.length &&
                                touched.dummy_journal_voucher_heads_Req[i]) ||
                              {};
                            return (
                              <>
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>
                                    <Field
                                      className="form-control"
                                      name={`dummy_journal_voucher_heads_Req.${i}.headid`}
                                    >
                                      {({ field }) => (
                                        <select
                                          {...field}
                                          onChange={(e) => {
                                            subhandleHeadNames(
                                              e,
                                              field,
                                              values,
                                              setFieldValue,
                                              `${i}`
                                            );
                                            setHeadSelected(
                                              e.target.value !== "0"
                                            );
                                          }}
                                          className={
                                            "form-control" +
                                            (dummy_journal_voucher_heads_ReqErrors.headid &&
                                              dummy_journal_voucher_heads_ReqTouched.headid
                                              ? " is-invalid"
                                              : "")
                                          }
                                        >
                                          {" "}
                                          <option value="0">
                                            --Select--
                                          </option>
                                          {headNamesList}
                                        </select>
                                      )}
                                    </Field>
                                    <ErrorMessage
                                      name={`dummy_journal_voucher_heads_Req.${i}.headid`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </td>

                                  <td>
                                    <Field
                                      name={`dummy_journal_voucher_heads_Req.${i}.subheadid`}
                                    >
                                      {({ field }) => (
                                        <select
                                          {...field}
                                          onChange={(e) =>
                                            subNames(
                                              e,
                                              field,
                                              values,
                                              setValues
                                            )
                                          }
                                          className={
                                            "form-control" +
                                            (dummy_journal_voucher_heads_ReqErrors.subheadid &&
                                              dummy_journal_voucher_heads_ReqTouched.subheadid
                                              ? " is-invalid"
                                              : "")
                                          }
                                        >
                                          <option value="0">
                                            --Select--
                                          </option>
                                          {HeadersList?.subHeadOptions}
                                        </select>
                                      )}
                                    </Field>
                                  </td>

                                  <td>
                                    <Field
                                      name={`dummy_journal_voucher_heads_Req.${i}.credit`}
                                      id={`credit_${i}`}
                                      {...ref}
                                      type="text"
                                      onKeyPress={(e) =>    NumberValidation(e)  }
                                      className={
                                        "form-control" +
                                        (dummy_journal_voucher_heads_ReqErrors.credit &&
                                          dummy_journal_voucher_heads_ReqTouched.credit
                                          ? " is-invalid"
                                          : "")
                                      }
                                    />
                                    <ErrorMessage
                                      name={`dummy_journal_voucher_heads_Req.${i}.credit`}
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </td>
                                  <td>
                                    <AiFillPlusCircle
                                      onClick={() => {
                                        setSelectedHeadIds([
                                          ...selectedHeadIds,
                                          headId,
                                        ]);
                                        push({
                                          headid: "",
                                          subheadid: "",
                                          credit: "",
                                        });
                                      }}
                                      style={{
                                        fontSize: "21px",
                                        color: "green",
                                      }}
                                    />

                                    {i > 0 && (
                                      <AiFillMinusCircle
                                        onClick={() => remove(i)}
                                        style={{
                                          fontSize: "21px",
                                          color: "red",
                                        }}
                                      />
                                    )}
                                  </td>
                                </tr>
                              </>
                            );
                          }
                        )}
                      </tbody>

                      <tfoot>
                        <tr>
                          <th colSpan={3}>Total</th>

                          <th>
                            {values?.dummy_journal_voucher_heads_Req
                              ?.reduce(
                                (sum, row) =>
                                  parseFloat(row?.credit || 0) + sum,
                                0
                              )
                              .toLocaleString("en-IN", {
                                style: "currency",
                                currency: "INR",
                              })}
                          </th>
                        </tr>
                      </tfoot>
                    </Table>
                  )}
                </FieldArray>
              </OFMSUI.Row>
              <OFMSUI.Row>
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={4}
                  xl={4}
                  xxl={4}
                  className="m-2"
                >
                  <label>
                    <b>File Upload (File name should not contain symbols or special characters.)</b>
                    <span className="text-danger">*</span>
                  </label>
                  <InputGroup>
                    <input
                      type="file"
                      name="file"
                      id="file"
                      onChange={(e) => { handleChange(e) }}
                      className={touched.file && errors.file ? "form-control is-invalid" : "form-control"}
                    />
                  </InputGroup>
                  <ErrorMessage name="file" component="div" className="text-danger" />
                </OFMSUI.Col>
              </OFMSUI.Row>

              <br></br>
              <OFMSUI.Row className="m-2">
                <OFMSUI.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={1}
                  xl={1}
                  xxl={1}
                  className=""
                >
                  <div className="d-grid  ">
                    <button
                      className="btn btn-secondary btn-sm"
                      type="reset"
                      onClick={resetForm}
                    >
                      Clear
                    </button>
                  </div>
                </OFMSUI.Col>


                <center>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}>
                    {" "}
                    <button className="btn btn-success btn-md" type="submit">
                      Submit
                    </button>
                  </OFMSUI.Col>
                </center>
              </OFMSUI.Row>
            </OFMSUI.Container>
          </Form>
        ) : (
          ""
        )
        }
      </Formik>
    </>
  );
};

export default GenerationReceipt;
